module.exports = __webpack_public_path__ + "img/work-categories-buttons-add.39dc353e.svg";